import Columns from './columns';
import {displayModes} from '../../../services/enums/displayModes';

// CARE: ALWAYS INCREMENT THE VERSION IF THE SETTINGS FOR A COLUMN CHANGE!
// Config explanation
// optional: determines if the hidden status can be changed by the user
// hidden: determines if the field is shown or hidden
// conditional: indicates that the hidden status can be overriden using the conditions dictionary of the useTableConfig hook
const DefaultConfig = {
  [displayModes.admin]: {
    version: 1,
    columns: {
      vehicleName: {
        columnName: Columns.vehicleName.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 1,
      },
      vehicleType: {
        columnName: Columns.vehicleType.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 2
      },
      vehicleCapacity: {
        columnName: Columns.vehicleCapacity.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 3
      },
      vehicleVolume: {
        columnName: Columns.vehicleVolume.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 4
      },
      vehiclePayloadWeight: {
        columnName: Columns.vehiclePayloadWeight.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 5
      },
      carrier: {
        columnName: Columns.carrier.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 6
      },
    }
  },
  [displayModes.carrier]: {
    version: 1,
    columns: {
      vehicleName: {
        columnName: Columns.vehicleName.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 1,
      },
      vehicleType: {
        columnName: Columns.vehicleType.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 2
      },
      vehicleCapacity: {
        columnName: Columns.vehicleCapacity.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 3
      },
      vehicleVolume: {
        columnName: Columns.vehicleVolume.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 4
      },
      vehiclePayloadWeight: {
        columnName: Columns.vehiclePayloadWeight.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 5
      },
      vehicleDelete: {
        columnName: Columns.vehicleDelete.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 6
      },
    }
  },
  [displayModes.shipper]: {
    version: 1,
    columns: {}
  },
}

export default DefaultConfig;